/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */


import { AppContext } from 'plugin/liferay-widgets-react-web';
import LayerWebApi from '../webapi/LayerDataSourceWebApi';
import MapConfigWebApi from '../webapi/MapConfigWebApi';

import ActionTypes from '../constants/ActionTypes';

export default {

    loadMapConfig(uuid) {
        AppContext.getDispatcher().dispatchAsyncOperation(ActionTypes.LOAD_MAP_CONFIG_ASYNC, MapConfigWebApi.loadMapConfig, {}, {});
    },

    loadStaticLayers() {
        AppContext.getDispatcher().dispatchAsyncOperation(ActionTypes.REQUEST_STATIC_LAYERS, LayerWebApi.loadLayers, {}, {});
    },

    saveDemoMapConfig() {
        AppContext.getDispatcher().dispatchAsyncOperation(ActionTypes.SAVE_MAP_CONFIG_ASYNC, MapConfigWebApi.saveDemoMapConfig, {}, {});
    },

    addLayer(/* object or array */ layer) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypes.ADD_LAYER,
            payload: layer
        });
    },

    selectLayer(layerId) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypes.SELECT_LAYER,
            payload: layerId
        });
    },

    deselectLayer(layerId) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypes.DESELECT_LAYER,
            payload: layerId
        });
    }
};



// WEBPACK FOOTER //
// ./js/actions/MapActions.js